<template>
  <v-app>
    <navigation :color="color" :flat="flat"/>
    <v-main class="pt-0">
      <home/>
      <order/>
      <call_dialog/>
      <sec1/>
      <pricing/>

      <expert/>
      <stock/>


      <situation/>
      <advantages/>
<!--      <social_net/>-->
      <feedback/>
<!--      <expert2/>-->
      <request/>
      <contact />
      <faq_panel/>
    </v-main>
    <v-scale-transition>
      <v-btn
          fab
          v-show="fab"
          v-scroll="onScroll"
          dark
          fixed
          bottom
          right
          color="secondary"
          @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <foote />
    <info_panel/>
  </v-app>
</template>

<style scoped>
</style>

<script>
import navigation from "./components/Navigation";
import foote from "./components/Footer";
import home from "./components/HomeSection";
import order from "./components/OrderSection";
import sec1 from "./components/Section1";
import pricing from "./components/PricingSection";
import expert from "./components/ExpertSection";
import situation from "./components/SituationSection";
import advantages from "./components/Advantages";
import feedback from "./components/Feedback";
import expert2 from "./components/ExpertSection2";
import request from "./components/Request";
import contact from "./components/ContactSection";
import faq_panel from "./components/Faq";
import call_dialog from "./components/CallDialog";
import stock from "./components/Stock";
import info_panel from "./components/InfoPanel";

export default {
  name: "App",

  components: {
    navigation,
    foote,
    home,
    order,
    sec1,
    pricing,
    expert,
    situation,
    advantages,
    feedback,
    expert2,
    request,
    contact,
    faq_panel,
    call_dialog,
    info_panel,
    stock
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
